import { Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";

export function Header() {
  const location = useLocation();

  return (
    <header className="sticky top-0 z-50 w-full border-b border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container flex h-16 items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <img src="/logo.png" alt="" className="h-12 w-auto" />
          <span className="font-display text-xl font-bold text-foreground/80">
            WanderDaddy
          </span>
        </Link>

        <nav className="flex items-center gap-6">
          <Link
            to="/"
            className={cn(
              "text-sm font-medium transition-colors hover:text-primary",
              location.pathname === "/" ? "text-foreground" : "text-muted-foreground"
            )}
          >
            Experiences
          </Link>
          <Link
            to="/stories"
            className={cn(
              "text-sm font-medium transition-colors hover:text-primary",
              location.pathname.startsWith("/stories") ? "text-foreground" : "text-muted-foreground"
            )}
          >
            Stories
          </Link>
        </nav>
      </div>
    </header>
  );
}
